// @ts-nocheck
import GenericMobileRenderWrestlerWhenNumberInSide from '../GenericUtilitiesComponents/GenericMobileRenderWrestlerWhenNumberInSide';

function MobileRenderWrestlerWhenTwoInSide({ wrestler, side }) {
    return (
        <GenericMobileRenderWrestlerWhenNumberInSide
         wrestler={wrestler}
         side={side}
         heightCardPercentage='50%'
         heightPixelAvatar='40px'
         widthPixelAvatar='40px'
        />
    )
}

export default MobileRenderWrestlerWhenTwoInSide;